// Klíče v localStorage / Preferences na jednom místě.
//
// Vlastní modul (ne App.tsx), aby je mohl číst i non-React kód — sessionReset
// je musí umět smazat, a import z App.tsx by udělal cyklus
// App → authStore → sessionReset → App.

/** Poslední navštívená cesta (obnova po restartu app). */
export const LAST_PATH_KEY = "routera:lastPath";

/** ID naposledy přihlášeného řidiče — pozná změnu řidiče na stejném telefonu. */
export const LAST_DRIVER_KEY = "routera:lastDriverId";

/** Zastávky s vydaným materiálem + potvrzení dne (materialStore). */
export const MATERIAL_STOPS_KEY = "routera:material_stops";
export const MATERIAL_CONFIRMED_KEY = "routera:material_confirmed";

/** Prefix denních klíčů odkliknutého storna (stornoAckStore). */
export const STORNO_ACK_PREFIX = "routera.storno.acked.";
